export const personelPermissionColumns = () => [
  {
    field: "dayoffTypeName",
    headerName: "İzin Türü",
    sortable: false,
    filterable: false,
    flex: 1,
  },
  {
    field: "dayoffRightCount",
    headerName: "Toplam İzin Hakkı",
    sortable: false,
    filterable: false,
    flex: 1,
  },
  {
    field: "dayoffUsedCount",
    headerName: "Kullanılan İzin Sayısı",
    sortable: false,
    filterable: false,
    flex: 1,
  },
  {
    field: "usableDayoffCount",
    headerName: "Kalan İzin Sayısı",
    sortable: false,
    filterable: false,
    flex: 1,
  },
];
